<section class="mb-20">
    <div class="mt-5 relative">
      <div
        class="w-full bg-[#285CA5] h-[124px] rounded-t-xl flex items-center justify-end gap-3"
      >
        <div class="pr-8">
        </div>
      </div>
  
      <div class="w-full h-[124px] flex items-center">
        <div class="ml-64 flex items-start justify-between w-full">
          <div>
            <div class="flex items-center space-x-3">
              <div
                class="w-[17px] h-[17px] rounded-full"
                [style.background-color]="client?.active ? '#52D3C4' : '#FF6B6B'"
              ></div>
              <p class="text-2xl font-bold m-0 text-[#000000A6]">
                {{ client?.name
                }}<span class="text-[#526ED3] text-base font-medium">
                  {{ getClientIdentifier(client) }}</span
                >
              </p>
            </div>
            <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">
              {{ getOnboardingLabel(client) }}
            </p>
          </div>
        </div>
      </div>
      <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
        <img
          class="object-cover w-full h-full rounded-full"
          src="{{ client?.profilePic }} "
          alt=""
        />
      </div>
    </div>
  
    <div class="flex items-center mt-10 space-x-5">
      <div
        class="w-[40px] h-[40px] bg-[#285CA5] rounded-full flex items-center justify-center cursor-pointer"
        (click)="goBack()"
      >
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.58893 1.16156C7.91437 1.487 7.91437 2.01463 7.58893 2.34007L3.17819 6.75081H12.833C13.2932 6.75081 13.6663 7.12391 13.6663 7.58415C13.6663 8.04438 13.2932 8.41748 12.833 8.41748H3.17819L7.58893 12.8282C7.91437 13.1537 7.91437 13.6813 7.58893 14.0067C7.26349 14.3322 6.73586 14.3322 6.41042 14.0067L0.577085 8.1734C0.251649 7.84797 0.251649 7.32033 0.577085 6.99489L6.41042 1.16156C6.73586 0.836121 7.26349 0.836121 7.58893 1.16156Z"
            fill="white"
          />
        </svg>
      </div>
      <p class="text-xl text-[#000000A6] font-bold">
          {{ getMonthName(month) }} - {{ year }} Charges
        </p>
        
    </div>
  
    <div class="flex items-center mt-2 space-x-20">
      <div class="flex flex-col">
        <p class="text-sm text-[#595959] font-medium mb-0">Number of Shifts</p>
        <p class="text-[#6B6D80] text-xl font-bold mt-0 pt-0">
          {{ getTotalShifts() }}
        </p>
      </div>
      <div class="flex flex-col">
        <p class="text-sm text-[#595959] font-medium mb-0">Net Charge</p>
        <p class="text-[#285CA5] text-xl font-bold mt-0 pt-0">
          {{ getNetCharge() | number : "1.2-2" }} LKR
        </p>
      </div>
    </div>
  
    <p class="text-[#3E4A58] text-base font-medium mt-0 pt-0">
      Shift History
    </p>
    <div class="w-full">
      <table
        tuiTable
        size="m"
        class="md:w-full"
      >
        <thead>
          <tr>
            <th tuiTh style="background-color: #285ca5; color: white">Date</th>
            <th tuiTh style="background-color: #285ca5; color: white">Nurse name</th>
            <th tuiTh style="background-color: #285ca5; color: white">Roster</th>
            <th tuiTh style="background-color: #285ca5; color: white">Meal Option</th>
            <th tuiTh style="background-color: #285ca5; color: white">Shift Type</th>
            <th tuiTh style="background-color: #285ca5; color: white">Address</th>
            <th tuiTh style="background-color: #285ca5; color: white">Shift Charges</th>
            <th tuiTh style="background-color: #285ca5; color: white">
              Start Time
            </th>
            <th tuiTh style="background-color: #285ca5; color: white">
              End Time
            </th>
          </tr>
        </thead>
        <tbody tuiTbody>
          <!-- Loop through each record and its shifts -->
          <ng-container *ngFor="let record of ChargesRecords">
            <ng-container *ngFor="let shift of record.shifts">
              <tr>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#526ED3] text-sm">
                      {{ shift.date | date : "dd MMM yyyy" }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">{{ shift.nurseID.name ?? 'Unavailable' }}</p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ shift.rooster }} Hour
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">{{ shift.mealOption }}</p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">{{ shift.shiftType }}</p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">{{ (shift.address?.length || 0) > 20 ? (shift.address | slice:0:40) + '...' : shift.address }}</p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">LKR {{ shift.charges | number : "1.2-2" }}</p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ shift.startTime | date : "shortTime" }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0; padding-bottom: 0">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ shift.endTime | date : "shortTime" }}
                    </p>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
  